"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Result () {
        return Result;
    },
    get RouteType () {
        return RouteType;
    },
    get ServerlessType () {
        return ServerlessType;
    }
});
var RouteType = /*#__PURE__*/ function(RouteType) {
    RouteType["GET"] = "get";
    RouteType["POST"] = "post";
    RouteType["PUT"] = "put";
    RouteType["PATCH"] = "patch";
    RouteType["DELETE"] = "delete";
    RouteType["HEAD"] = "head";
    RouteType["OPTIONS"] = "options";
    return RouteType;
}({});
var ServerlessType = /*#__PURE__*/ function(ServerlessType) {
    ServerlessType["AWS_LAMBDA"] = "AWS_LAMBDA";
    ServerlessType["GCP_FUNCTION"] = "GCP_FUNCTION";
    ServerlessType["AZURE_FUNCTION_APP"] = "AZURE_FUNCTION_APP";
    ServerlessType["ALIYUN"] = "ALIYUN";
    ServerlessType["ZEIT"] = "ZEIT";
    ServerlessType["LYRID"] = "LYRID";
    ServerlessType["SERVERLESS"] = "SERVERLESS";
    return ServerlessType;
}({});
let Result = class Result {
    constructor(code = 0, message = '', data = {}){
        this.code = code;
        this.message = message;
        this.data = data;
    }
};
var HTTPType = /*#__PURE__*/ function(HTTPType) {
    HTTPType["GET"] = "get";
    HTTPType["POST"] = "post";
    HTTPType["PUT"] = "put";
    HTTPType["DELETE"] = "delete";
    HTTPType["PATCH"] = "patch";
    HTTPType["HEAD"] = "head";
    HTTPType["OPTIONS"] = "options";
    return HTTPType;
}(HTTPType || {});
